module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("fG5zv"))).then(() => parcelRequire('ljYL6'));